import React, {FC, useState} from 'react';
import st from './mainAsideMenuLayout.module.scss';
import cn from 'classnames'
import MenuToolbar from "../../modules/main/menuToolbar/MenuToolbar";

interface MainAsideMenuLayout {
  children?: React.ReactNode
}

const MainAsideMenuLayout: FC<MainAsideMenuLayout> = ({children}) => {
  
  const controlOpenMenu = useState<boolean>(false)
  const controlOpenQuick = useState<boolean>(false)
  
  const [isOpenMenu, setIsOpenMenu] = controlOpenMenu;
  const [isOpenQuick, setIsOpenQuick] = controlOpenQuick;
  
  
  return (
    <div className={st.container}>
      <div className={cn(
        st.menu,
        isOpenMenu ?
          st.menu__full :
          st.menu__fit
      )}>
        <MenuToolbar
          isOpenMenu={isOpenMenu}
          setIsOpenMenu={setIsOpenMenu}
        />
      </div>
      <div className={st.main}>
        {children}
      </div>
    </div>
  )
}
export default MainAsideMenuLayout;